module.exports = __webpack_public_path__ + "img/tooltip_07-vallone-litho-calce-antracite.c58ad425.jpg";